import FaultOverviewPage from "./FaultOverviewPage";
import { DataGridSettingsProvider } from "@/components/DataGridSettingsProvider";
import { PresetProvider } from "@/components/PresetProvider";

export function FaultOverviewPageWrapper() {
  return (
    <PresetProvider scope="faultMonitor.preset">
      <DataGridSettingsProvider pageType="faultMonitor">
        <FaultOverviewPage />
      </DataGridSettingsProvider>
    </PresetProvider>
  );
}
